<template>
  <div class="pa-2">
    <div class="d-flex flex-column" :style="{ gap: '10px' }">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Consumer',
}
</script>
